import { memo, useEffect } from "react";
import { NumberInput } from "react-admin";
import { useFormContext, useWatch } from "react-hook-form";

const QuantityInput = ({ quantity, formData, ...props }) => {
  const { setValue, getValues } = useFormContext();
  
  // Watch nilai quantity di field ini
  const me = useWatch({ name: props.source });
  
  // ⭐⭐⭐ Watch SEMUA items, bukan hanya length ⭐⭐⭐
  const allItems = useWatch({ name: 'sale_order_items' }) || [];
  
  useEffect(() => {
    // Gunakan allItems yang sudah di-watch, bukan formData prop
    let total = 0;
    
    for (let i = 0; i < allItems.length; i++) {
      const elm = allItems[i];
      if (elm && elm.quantity && elm.price) {
        const qty = parseFloat(elm.quantity) || 0;
        const price = parseFloat(elm.price) || 0;
        total += qty * price;
      }
    }
    
    console.log('🔄 QuantityInput updating total:', total);
    setValue("total", total, { shouldDirty: true });
    
  }, [me, allItems]); // ⭐⭐⭐ Watch allItems, bukan hanya length ⭐⭐⭐

  return (
    <NumberInput
      {...props}
      inputProps={{ type: "text", inputMode: "numeric", pattern: "[0-9]*" }}
    />
  );
};

const propsAreEqual = (prevProps, nextProps) => {
  if (
    prevProps.quantity === nextProps.quantity &&
    prevProps.source === nextProps.source
  ) {
    return true;
  }
  return false;
};

export default memo(QuantityInput, propsAreEqual);